/**
 * The Loka wordmark, as it sits in the artifact's header.
 *
 * The artifact ships it as an <img> of the brand-blue SVG with
 * `filter:brightness(0) invert(1)` on top, because a bitmap-style asset cannot
 * take a colour. Inlined, the paths take `currentColor` instead, so the bar's
 * text colour is the only thing that decides it — and no hex leaves
 * `theme/`.
 */
interface LokaMarkProps {
  className?: string
}

export default function LokaMark({ className }: LokaMarkProps) {
  return (
    <svg
      className={className}
      width="58"
      height="20"
      viewBox="0 0 58 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M0 3.46593L2.68389 3.46271L2.69639 13.8808L8.24518 13.8741L8.24842 16.568L0.0157328 16.5779L0 3.46593Z" />
      <path d="M31.8543 3.42771L34.7173 3.42428L34.7255 10.2499L41.7258 3.41587L45.2757 3.41161L38.9891 9.69189L38.8257 9.83274L43.4985 14.5175L54.5516 3.40048L57.0856 3.39744L57.1012 16.3297L54.4173 16.3329L54.4063 7.17289L45.4392 16.3437L41.7121 16.3482L37.2614 11.8487L37.0607 11.6477L34.7299 13.9479L34.733 16.5363L31.8701 16.5397L31.8543 3.42771Z" />
      <path d="M19.7702 7.19449e-06C14.3518 0.0065086 9.96442 4.42086 9.97094 9.8614C9.97747 15.3 14.3755 19.7058 19.7958 19.6992C25.2161 19.6927 29.6036 15.2784 29.597 9.83785C29.5886 4.39732 25.1906 -0.00649655 19.7702 7.19449e-06ZM19.7166 16.9742C15.7891 16.9789 12.5992 13.7868 12.5945 9.84263C12.5898 5.90043 15.77 2.69871 19.6995 2.69399C23.629 2.68928 26.8169 5.88141 26.8216 9.82555C26.8264 13.7697 23.6442 16.9695 19.7166 16.9742Z" />
      <path d="M21.9295 9.84695C21.9309 11.021 20.9844 11.9735 19.815 11.9749C18.6455 11.9763 17.6968 11.0261 17.6954 9.85203C17.694 8.67797 18.6404 7.72547 19.8099 7.72406C20.9793 7.72266 21.9281 8.67289 21.9295 9.84695Z" />
    </svg>
  )
}
